module.exports = __webpack_public_path__ + "img/receivables-my-wallet.3e5c0b2f.svg";